import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { darkGrayFontColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	card: {
		boxSizing: 'border-box',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		width: '100%',
		':has(*) *': {
			boxSizing: 'border-box',
		},
	},
	cardHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	headerContent: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	icon: {
		alignItems: 'center',
		color: THEME.colors.primary.main,
		borderRadius: 12,
		display: 'flex',
		flexShrink: 0,
		justifyContent: 'center',
	},
	title: {
		color: THEME.colors.text.dark,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		paddingLeft: 32,
	},
	description: {
		color: darkGrayFontColor,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
	},
});
